export const NEW_PATIENT_VISIT_FEES = 1100;
export const REGULAR_PATIENT_VISIT_FEES = 1000;

/**
 * Default consultation fee:
 * - free patients → 0
 * - first visit (new patient) → 1100 (or a stored registration fee)
 * - return visits → always 1000 (never reuse a leftover first-visit 1100 on the patient row)
 */
export function resolveDefaultVisitFees(options: {
  isFree?: boolean;
  isNewPatient?: boolean;
  storedVisitFees?: number | string | null;
}): number {
  if (options.isFree) {
    return 0;
  }

  if (!options.isNewPatient) {
    return REGULAR_PATIENT_VISIT_FEES;
  }

  const stored = options.storedVisitFees;
  if (stored != null && stored !== '') {
    const amount = Number(stored);
    if (Number.isFinite(amount) && amount >= 0) {
      return amount;
    }
  }

  return NEW_PATIENT_VISIT_FEES;
}

/** Clamp discount to a whole percent between 0 and 100. */
export function normalizeDiscountPercent(value: unknown): number {
  const amount = Number(value);
  if (!Number.isFinite(amount) || amount <= 0) {
    return 0;
  }
  return Math.min(100, Math.max(0, Math.round(amount)));
}

/** Apply visit discount % to a base fee (100% → free this visit). */
export function applyVisitDiscount(baseFee: number, discountPercent: unknown): number {
  const base = Number(baseFee);
  if (!Number.isFinite(base) || base <= 0) {
    return 0;
  }

  const discount = normalizeDiscountPercent(discountPercent);
  if (discount <= 0) {
    return Math.round(base);
  }
  if (discount >= 100) {
    return 0;
  }

  return Math.round((base * (100 - discount)) / 100);
}
